import { BaseErrorHero } from "./BaseErrorHero";

export const InternalErrorHero = () => {
  return <BaseErrorHero hero="Oops!" description="An error has occurred." />;
};
